import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabaseClient';

const FavouritesContext = createContext(null);

function getSessionId() {
  let id = localStorage.getItem('sa_session_id');
  if (!id) {
    id = 'sess_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
    localStorage.setItem('sa_session_id', id);
  }
  return id;
}

export function FavouritesProvider({ children }) {
  const [favourites, setFavourites] = useState([]);
  const sessionId = getSessionId();

  const fetchFavourites = useCallback(async () => {
    const { data } = await supabase
      .from('favourites')
      .select('*')
      .eq('session_id', sessionId);
    setFavourites(data || []);
  }, [sessionId]);

  useEffect(() => { fetchFavourites(); }, [fetchFavourites]);

  const isFavourited = (productId) =>
    favourites.some(f => f.product_id === String(productId));

  const toggleFavourite = async (product) => {
    const pid = String(product.id);
    if (isFavourited(pid)) {
      await supabase
        .from('favourites')
        .delete()
        .eq('session_id', sessionId)
        .eq('product_id', pid);
    } else {
      await supabase.from('favourites').insert([{
        session_id:    sessionId,
        product_id:    pid,
        product_name:  product.name,
        product_brand: product.brand,
        product_image: product.images?.[0] || '',
        product_price: product.price,
      }]);
    }
    fetchFavourites();
  };

  return (
    <FavouritesContext.Provider value={{ favourites, isFavourited, toggleFavourite, fetchFavourites }}>
      {children}
    </FavouritesContext.Provider>
  );
}

export const useFavourites = () => useContext(FavouritesContext);